import
  React
from 'react';

import
  PropTypes
from 'prop-types';

import {
  withScreenViewTagging
} from 'hocs';

import {
  CustomColors
} from '../../../../constants';

import {
  getStorageWithExpiry
} from 'helpers';

import {
  ConfirmationForm
} from '../components';

const VoucherAdvanceAboutUI = (props) => {

  VoucherAdvanceAboutUI.pageName = `cbu: connectu: voucher advance: about your voucher: ${props.validity}`;

  VoucherAdvanceAboutUI.tagViewData = {
    page_section: 'voucher advance',
    visitor_customer_segment: getStorageWithExpiry('msisdn', 'msisdnType', ''),
    visitor_type: 'consumer',
    visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', '')
  };

  const formatDescription = () => {

    let description = props.description;

    if (!description) {

      return;
    }

    return description.replace(/\. /g, '.\n');
  };

  return (

    <ConfirmationForm
      title={'About your voucher'}
      description={formatDescription()}
      onPrimaryClick={props.onPrimaryClick}
      onSecondaryClick={props.onSecondaryClick}/>
  );
};

VoucherAdvanceAboutUI.propTypes = {
  buttonColor: PropTypes.string,
  onPrimaryClick: PropTypes.func,
  onSecondaryClick: PropTypes.func,
  description: PropTypes.string,
  validity: PropTypes.string
};

VoucherAdvanceAboutUI.defaultProps = {
  buttonColor: CustomColors.Red1,
  onPrimaryClick: () => {},
  onSecondaryClick: () => {},
  description: '',
  validity: ''
};

export const VoucherAdvanceAbout = withScreenViewTagging(VoucherAdvanceAboutUI);